<template>
    <div class="home page">
        <NavControl :route="false"/>
        <div class="grid">
            <div class="main column collapse-right">
                <Features v-model="mainFeatures" :bus="bus"/>
            </div>
            <div class="side column collapse-left">
                <div class="text-right">
                    <div class="text-center">
                        <h2>Which&nbsp;<strong>vehicle type</strong>&nbsp;you prefer?</h2>
                        <div class="text-right">
                            <Box
                                title="Hatchback"
                                :index="0"
                                name="carType"
                                :value="carSelected"
                                @change="changeCarType"
                                customClass="car"
                            />
                            <Box
                                title="Combi"
                                :index="2"
                                name="carType"
                                :value="carSelected"
                                @change="changeCarType"
                                customClass="second car"
                            />
                            <Box
                                title="Sedan"
                                :index="1"
                                name="carType"
                                :value="carSelected"
                                @change="changeCarType"
                                customClass="car"
                            />
                            <Box
                                title="SUV"
                                :index="3"
                                name="carType"
                                :value="carSelected"
                                @change="changeCarType"
                                customClass="second car"
                            />
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <h2>What is&nbsp;<strong>the budget</strong>&nbsp;for a new car?</h2>
                    <div class="box-wrapper">
                        <Box
                            title="Up to <br/><strong>400 000 CZK</strong>"
                            :index="0"
                            customClass="price-box"
                            name="priceType"
                            :value="priceSelected"
                            @change="changePriceType"
                        />
                        <Box
                            title="400 000 CZK <strong>600 000 CZK</strong>"
                            :index="1"
                            customClass="price-box"
                            name="priceType"
                            :value="priceSelected"
                            @change="changePriceType"
                        />
                        <Box
                            title="Over<br><strong>600 000 CZK</strong>"
                            :index="2"
                            customClass="price-box"
                            name="priceType"
                            :value="priceSelected"
                            @change="changePriceType"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <img src="./../assets/skoda-logo.png" alt="">
            <transition name="fade-in">
                <div class="button-wrapper" v-if="displayControl">
                    <a href="" class="button clear-button" @click.prevent="reset">
                        Reset
                    </a>
                    <a class="button continue"
                       @click.prevent="handleRoute()"
                       replace
                    >
                        Confirm
                    </a>
                </div>
            </transition>
        </div>
        <transition name="scale-up">
            <div class="modal" v-if="showModal" @click.prevent="showModal = false">
                <div class="modal-content" @click.stop>
                <span
                    class="modal-close"
                    @click.prevent="showModal = false"
                >&times;</span>
                    <div>Invalid combination of vehicle type and price.</div>
                    <div>Please, choose another option.</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue';
    import NavControl from '@/components/nav-control.vue';
    import Box from '@/components/Box.vue';
    import Features from '@/components/Features.vue';

    export default {
        name: 'home',
        data() {
            return {
                carSelected: null,
                priceSelected: null,
                mainFeatures: [],
                bus: new Vue(),
                showModal: false,
            };
        },
        computed: {
            displayControl() {
                return this.mainFeatures.length > 0 && (null !== this.priceSelected) && (null !== this.carSelected);
            }
        },
        methods: {
            changeCarType(newValue) {
                this.carSelected = newValue;
            },
            changePriceType(newValue) {
                this.priceSelected = newValue;
            },

            reset() {
                this.carSelected = null;
                this.priceSelected = null;
                this.mainFeatures = [];
                this.bus.$emit('resetFeatures');
            },

            handleRoute() {
                if ((this.carSelected === 3 && this.priceSelected === 0) || (this.priceSelected === 2 && this.carSelected === 0)) {
                    this.showModal = true;
                } else {
                    this.$router.push({
                        name: 'about',
                        params: {
                            data: {
                                'carSelected': this.carSelected,
                                'priceSelected': this.priceSelected,
                                'mainFeatures': this.mainFeatures
                            }
                        }
                    })
                }
            }
        },
        components: {
            NavControl,
            Box,
            Features,
        },
    };
</script>
